<template>
  <master-layout id="gpcrContentResourceSessions" no-bottom-pad>
    <div
      v-if="!isPageLoading"
      class="lg:flex-1 lg:overflow-hidden relative font-aktiv-grotesk lg:pb-[142px] bg-[#F8F9F9]"
    >
      <ResourcesContainer
        ref="resourceContainer"
        :show-more-resources="moreResourcesCount > 0"
      >
        <div
          class="md:ml-[24px] lg:ml-0 md:flex md:justify-between px-6 md:px-0"
        >
          <p class="font-aktiv-grotesk text-[16px] leading-[24px] pb-8">
            {{ $t("copy.resourcesPage.description") }}
          </p>
          <div
            class="md:ml-0 border-[2px] border-grey-40 text-[#637083] rounded-xl h-[48px] w-full md:w-[400px] flex flex-row items-center py-[10px] px-3 md:mx-6 cursor-pointer hover:opacity-80"
            @click="this.$router.push('/resources/sessions/search')"
          >
            <img
              class="mr-2"
              fill="#637083"
              src="/assets/icons/search.svg"
              alt=""
            />
            <p>{{ $t("copy.resourcesPage.searchBar") }}</p>
          </div>
        </div>
        <div class="font-aktiv-grotesk">
          <ResourcesSection />
        </div>
      </ResourcesContainer>
    </div>
    <div
      v-if="isPageLoading"
      class="w-screen h-screen flex items-center justify-center"
    >
      <loading-state />
    </div>
  </master-layout>
</template>

<script>
import ResourcesContainer from "../../../components/ResourcesPage/ResourcesContainer.vue";
import LoadingState from "@/components/common/LoadingState.vue";
import { mapState } from "vuex";
import { FirebaseAnalytics } from "@/utils/firebase-analytics-wrapper";
import ResourcesSection from "@/components/ResourcesPage/PlaybackResources/ResourcesSection.vue";
import { getCurrentLocale } from "@/utils/deviceLocale";

export default {
  name: "SessionsPage",
  components: {
    ResourcesContainer,
    LoadingState,
    ResourcesSection,
  },
  data() {
    return {
      hasInitiallyLoaded: false,
      isPageLoading: true,
    };
  },
  computed: {
    ...mapState("cms", ["sessionMaterials", "resources"]),
    ...mapState("player", ["playingPlayer"]),
    ...mapState("filter", [
      "sessions",
      "showFilterModal",
      "allResources",
      "filterType",
    ]),
  },
  async ionViewWillEnter() {
    if (!this.hasInitiallyLoaded) {
      this.isPageLoading = true;
    }
    const locale = await getCurrentLocale("Regional");
    // use Promise.all to fetch all the data at once
    await Promise.all([
      this.$store.dispatch("filter/fetchSchedule", {
        locale: locale,
        conferenceType: "Regional",
      }),
      this.$store.dispatch("filter/fetchAllResources", {
        locale: locale,
        conferenceType: "Regional",
      }),
      this.$store.dispatch("filter/fetchSearchSuggestions", {
        locale: locale,
        conferenceType: "Regional",
      }),
      this.$store.dispatch("filter/updateFilteredValues", {
        filteredSessions: [],
        filteredTopics: [],
      })
    ]);
    this.$nextTick(() => {
      this.hasInitiallyLoaded = true;
      this.isPageLoading = false;
    });
    FirebaseAnalytics.setScreenName({
      screenName: "resources",
      nameOverride: "ResourcesPage",
    });
  },
  async ionViewDidLeave() {
    const filterType = this.filterType;
    const showFilterModal = false;
    await this.$store.dispatch("filter/updateShowFilterModal", {
      showFilterModal,
      filterType,
    });
    await this.$store.dispatch("filter/clearState");
  },
  methods: {
    openFilterModal() {
      this.$store.dispatch("filter/updateShowFilterModal", true);
    },
  },
};
</script>

<style scoped>
.tool-shadow {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.shadow {
  box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.25);
}

.swiper-slide {
  max-width: 328px;
  align-items: flex-start;
  vertical-align: middle;
  border-radius: 10px;
  display: flex;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.swiper {
  list-style: none;
  z-index: 1;
  padding-bottom: 0px;
}

.download-button svg {
  fill: #00aae4;
}

.download-button:active svg {
  fill: #ffffff;
}

@media all and (min-width: 768px) {
  ::v-deep(.swiper-wrapper) {
    padding-left: 0;
  }
}
</style>
